var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewlocate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 58,
    viewBox: "0 0 40 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(-1456 -360)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(208 188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(-42 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1290 182)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "clock",
    d: "M11.167,0A11.167,11.167,0,1,0,22.333,11.167,11.179,11.179,0,0,0,11.167,0Zm5.311,16.942a.93.93,0,0,1-1.316,0L10.509,12.29a.926.926,0,0,1-.273-.658V5.583a.93.93,0,1,1,1.861,0v5.663l4.38,4.38a.93.93,0,0,1,0,1.316Zm0,0",
    transform: "translate(1298.833 190.833)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M15,0l6.75,12.917L30,25l-15-.833L0,25,8.25,12.917Z",
    transform: "translate(1491 418) rotate(180)",
    fill: "#ea4335"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewlocate);
export default __webpack_public_path__ + "static/media/newlocate.39897f80efc11d8831cb91374596e4b1.svg";
export { ForwardRef as ReactComponent };